import orderBy from 'lodash/orderBy'
import sum from 'lodash/sum'

import { NAME_SPACE } from '../onboardingReducer'

import { STEP_MACHINE } from './constants'

const productHasParent = (product, parent) =>
  product.parentProducts && product.parentProducts.includes(parent)

export const getState = state => state[NAME_SPACE]

export const getSteps = state => getState(state).steps
export const getCurrentStep = state => getSteps(state)[getState(state).currentStep]
export const getFurthestStep = state => getState(state).furthestStep
export const getMachineStep = state => getSteps(state).indexOf(STEP_MACHINE)

export const getOnboardingUserType = state => getState(state).userType
export const getOnboardingUser = state => getState(state).costObjectUser
export const getOnboardingCostObjectId = state => getState(state).costObjectId

export const getProducts = state => getState(state).products
export const getDockings = state =>
  getProducts(state).filter(product => product.categoryId === 10 || product.name === 'Docking')

export const getWorkType = state => getState(state).workType
export const getMachines = state =>
  getProducts(state).filter(product => product.workType && product.workType === getWorkType(state))
export const getOnboardingSelectedMachineId = state => getState(state).selectedMachineId

export const getImages = state => {
  const selectedProduct = getOnboardingSelectedMachineId(state)
  return getProducts(state).filter(product => {
    return product.categoryId === 14 && productHasParent(product, selectedProduct)
  })
}
export const getOnboardingSelectedImageId = state => getState(state).selectedImageId

export const displayMonitorStepSplash = state => getState(state).displayMonitorStepSplash
export const displayAccessoryStepSplash = state => getState(state).displayAccessoryStepSplash
export const displayInitialSplash = state => getState(state).displayInitialSplash
export const displayInitialSplashMngr = state => getState(state).displayInitialSplashMngr

export const getScreens = state => getProducts(state).filter(product => product.categoryId === 6)
export const getSelectedScreenId = state => getState(state).selectedScreenId
export const getDoubleScreen = state => getState(state).doubleScreen

export const getMouseAndKeyboards = state =>
  getProducts(state)
    .filter(product => [3, 11].includes(product.categoryId) && product.name !== 'Docking')
    .sort((a, b) => {
      if (a === 10) {
        return 1
      }
      if (b === 10) {
        return -1
      }
      return 0
    })

export const getAccessories = state => {
  const selectedProduct = getOnboardingSelectedMachineId(state)
  return getProducts(state).filter(
    product =>
      [2, 5, 7, 8, 9, 20, 21, 753, 1084].includes(product.categoryId) &&
      (!product.parentProducts || product.parentProducts.includes(selectedProduct))
  )
}

export const getSelectedProducts = state => getState(state).selectedProducts
export const isProductSelected = (state, pid) => {
  return getSelectedProducts(state).indexOf(pid) !== -1
}

export const getAllSelectedProductIds = state => {
  const pc = getOnboardingSelectedMachineId(state)
  const image = getOnboardingSelectedImageId(state)
  const screen = getSelectedScreenId(state)
  const doubleScreen = getDoubleScreen(state)
  const other = getSelectedProducts(state)
  const postage = getSelectedPostage(state)

  let products = []
  if (pc) products.push(pc)
  if (image) products.push(image)
  if (screen) {
    products.push(screen)
    if (doubleScreen) products.push(screen)
  }
  if (other) products.push(...other)
  if (postage) products.push(postage)

  return products
}

export const getAllSelectedProducts = state =>
  getAllSelectedProductIds(state).map(pid => getProducts(state).find(product => product.id === pid))

export const getOrderSum = state => sum(getAllSelectedProducts(state).map(product => product.price))

export const getOrderId = state => getState(state).orderId
export const getSelectedAddressId = state => getState(state).addressId

export const getOrder = (state, costObjectId) => ({
  costObjectId,
  products: getAllSelectedProductIds(state),
  addressId: getSelectedAddressId(state),
})

export const orderIsLoading = state => getState(state).orderIsLoading

export const getSelectedPostage = state => getState(state).postageProductId
export const getPostageProducts = state =>
  getProducts(state).filter(product => product.categoryId === 15)
export const getPostageProductFromZip = (state, zip) =>
  getPostageProducts(state).find(product => product.productName.includes(rangeFromZip(zip)))

const rangeFromZip = zip => {
  if (zip >= 7000) return 'FRAKT SONE 5'
  if (zip >= 6000) return 'FRAKT SONE 4'
  if (zip >= 4000) return 'FRAKT SONE 3'
  if (zip >= 2100) return 'FRAKT SONE 2'
  return 'FRAKT SONE 1'
}

export const getAddresses = state => orderBy(getState(state).addresses, 'city')
